import NeoSoho1 from '../Neo Soho/Neo Soho (1).webp'
import NeoSoho2 from '../Neo Soho/Neo Soho (2).webp'
import NeoSoho3 from '../Neo Soho/Neo Soho (3).webp'

const NeoSohoimages =[
NeoSoho1,NeoSoho2,NeoSoho3
]

export default NeoSohoimages;